import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useMutation } from '@tanstack/react-query';
import { useQueryCacheCommentHelpers } from '../utils/useQueryCacheCommentHelpers.js';
import { useWoody } from '../../woody/woody.js';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { dispatchFabricEvent } from '../../hooks/useFabricEvent.js';

const useMutationDeleteComment = () => {
  const { client } = useWoody();
  const { track } = useAnalytics();
  const { deleteCachedComment } = useQueryCacheCommentHelpers();
  const accessToken = useContextAccessToken();
  const mutation = useMutation({
    mutationFn: async ({ resourceId, commentId }) => {
      return await client.v2({
        endpoint: "/v2/resources/{resourceId}/comments/{commentId}",
        params: {
          commentId,
          resourceId
        }
      }, {
        query: {
          accessToken
        },
        method: "delete"
      });
    },
    onSuccess: (_, { commentId, resourceId }) => {
      track(AnalyticsEvents.DeletedComment, {
        commentId
      });
      dispatchFabricEvent("fabric-annotation-action-delete", {
        type: "delete-annotation",
        commentId,
        resourceId
      });
    },
    onMutate: ({ commentId, resourceId }) => {
      return deleteCachedComment(commentId, resourceId);
    },
    onError: (_error, _variables, context) => {
      console.error("Failed to delete comment", _error);
      context?.resetCacheToPreOptimisticState();
      context?.invalidateQueries();
    }
  });
  return mutation;
};

export { useMutationDeleteComment };
//# sourceMappingURL=useMutationDeleteComment.js.map
